import * as React from 'react';
import { FormattedInput } from '@blend/shared-react';
import { inputFormatters } from '@blend/ui-common';
import { getIdFromName } from 'login-components/Common/Inputs/inputUtils';
import InputContainer from '../InputContainer/InputContainer';

class UnformattedNumberInput extends React.Component<InputProps, {}> {
  render() {
    const { hidePlaceholder, input, label, maxLength, meta, placeholder } = this.props;
    const error = meta.touched && meta.error;
    const identifier = placeholder || 'Unformatted Number';

    return (
      <InputContainer name={input.name} error={error} active={meta.active} identifier={identifier} label={label}>
        <FormattedInput
          {...input}
          id={getIdFromName(input.name)}
          placeholder={hidePlaceholder ? null : placeholder || identifier}
          type="text"
          maxLength={maxLength}
          normalize={inputFormatters.UNFORMATTED_NUMBER.normalize}
          format={inputFormatters.UNFORMATTED_NUMBER.format}
        />
      </InputContainer>
    );
  }
}

export const UnformattedNumberInputConfig = {
  component: UnformattedNumberInput,
};

export const SSNVerificationInputConfig = {
  component: props => <UnformattedNumberInput {...props} maxLength={4} />,
  requiredLength: 4,
};

export default UnformattedNumberInput;
